import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import registerServiceWorker from './registerServiceWorker'
import { initializeAuthRequestGuard } from './composables/authRequestGuard'
import './assets/styles/global.css';
import 'materialize-css/dist/css/materialize.min.css'

// createApp(App).use(store).use(router).mount('#app')

async function initApp() {
  // Wait for Vuex store to be restored from IndexedDB
  if (store.restored) {
    await store.restored
  }

  initializeAuthRequestGuard()
  
  const app = createApp(App)
  
  app.use(store)
  app.use(router)
  
  app.mount('#app')
}

initApp()
registerServiceWorker(router)
